<template>
  <div v-show="isActive" :class="{ widgetContainer: !isFixed }" :id="isFixed ? 'layersIDFix' : 'layersID'">
    <div v-if="!isFixed" class="map-tool-window-header" :class="{ widgetHeader: !isFixed }" id="layersIDheader">
      <p class="map-tool-window-header-title">Lista de capas</p>
      <div class="map-tool-window-header-actions">
        <button class="control-btn" v-on:click="onClickModalNewLayer()">
          Añadir capa
        </button>

        <button class="control-btn" v-on:click="isHidden = !isHidden">
          <!-- <font-awesome-icon v-if="!isHidden" icon="minus"></font-awesome-icon>
          <font-awesome-icon v-else icon="plus"></font-awesome-icon> -->
         <svg  v-if="isHidden"
         viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
         <svg v-else
          viewBox="0 0 24 24"><line x1="5" y1="12" x2="19" y2="12"/></svg>
        </button>
        <button class="control-btn" v-on:click="exitLayers()">
          <!-- <font-awesome-icon icon="times"></font-awesome-icon> -->
                 <svg viewBox="0 0 24 24"><line x1="5" y1="5" x2="19" y2="19"/><line x1="19" y1="5" x2="5" y2="19"/></svg>
        </button>
      </div>
    </div>

    <!-- Search and Filter Section -->
    <div v-show="!isHidden" class="search-filter-section">
      <!-- Search Bar -->
      <div class="search-bar-container">
        <div class="search-bar">
          <font-awesome-icon icon="search" class="search-icon" />

          <!-- Typing dots indicator -->
          <transition name="fade">
            <div v-if="isDebouncing" class="typing-dots">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </transition>

          <input ref="searchInput" type="text" v-model="searchQuery" placeholder="Buscar capas..." class="search-input"
            aria-label="Buscar capas por nombre" @keydown.esc="clearSearch" @keydown.enter="forceSearch" />
          <transition name="fade">
            <button v-if="searchQuery" @click="clearSearch" class="clear-button" aria-label="Limpiar búsqueda"
              type="button">
              <font-awesome-icon icon="times" />
            </button>
          </transition>

          <!-- Pulse bar indicator -->
          <transition name="fade">
            <div v-if="isDebouncing" class="debounce-pulse-bar"></div>
          </transition>
        </div>
        <button class="btn btn-primary search-button" @click="forceSearch" :disabled="!searchQuery.trim()"
          aria-label="Buscar">
          Buscar
        </button>
      </div>

      <!-- Filter Type Selector -->
      <div class="filter-type-selector" role="group" aria-label="Tipo de filtro">
        <button v-for="filter in filterTypes" :key="filter.value" @click="setFilterType(filter.value)"
          :class="['filter-btn', { active: currentFilterType === filter.value }]"
          :aria-pressed="currentFilterType === filter.value" type="button">
          {{ filter.label }}
        </button>
      </div>

      <!-- Category Filter (Conditional) -->
      <transition name="slide-fade">
        <div v-if="currentFilterType === 'category'" class="category-filter">
          <div class="filter-header">
            <span class="filter-title">Seleccionar categorías</span>
            <button @click="toggleAllCategories" class="link-button" type="button">
              {{ allCategoriesSelected ? "Deseleccionar todo" : "Seleccionar todo" }}
            </button>
          </div>
          <div class="category-checkboxes">
            <div v-for="(cat, idx) in allCategories" :key="idx" class="checkbox-item">
              <input type="checkbox" :id="`cat-filter-${idx}`" v-model="selectedCategories" :value="idx" />
              <label :for="`cat-filter-${idx}`">{{ cat.name }}</label>
            </div>
          </div>
        </div>
      </transition>

      <!-- Result Summary -->
      <transition name="fade">
        <div v-if="hasSearchQuery || hasActiveFilters" class="result-summary">
          <span class="result-count">
            {{ filteredLayersCount }}
            {{ filteredLayersCount === 1 ? "capa encontrada" : "capas encontradas" }}
          </span>
          <button @click="resetAllFilters" class="reset-button" type="button">
            {{ resetButtonLabel }}
          </button>
        </div>
      </transition>
    </div>

    <div :class="{ widgetBody: !isFixed }" v-show="!isHidden">
      <div :class="{ resizable: !isFixed }">
        <!-- Loading State -->
        <div v-if="isSearching" class="loading-state">
          <div class="skeleton-item" v-for="n in 3" :key="n"></div>
        </div>

        <!-- Empty State -->
        <div v-else-if="
          filteredCategories.length === 0 && (hasSearchQuery || hasActiveFilters)
        " class="empty-state">
          <font-awesome-icon icon="search" class="empty-icon" />
          <h3>No se encontraron capas</h3>
          <p>Intenta ajustar tu búsqueda o filtros</p>
          <button @click="resetAllFilters" class="btn btn-secondary" type="button">
            Limpiar filtros
          </button>
        </div>

        <!-- Results List -->
        <ListPlegable v-else v-for="(category, i) in filteredCategories" :key="i" :category="category" :index="i"
          :search-query="hasSearchQuery ? debouncedSearchQuery : ''" :is-search-active="hasSearchQuery"
          @selectLayer="onClickSelectLayer" @removeLayer="onClickRemoveLayer" @layerAttributes="getLayerInfo"
          @updateOpacity="onUpdateOpacity" />
      </div>
    </div>
  </div>
</template>

<script>
import ListPlegable from "@/components/mapTools/layers/ListPlegable.vue";
import { draggableDiv } from "@/components/mixin/draggableDiv.js";
import { vuex } from "@/components/mixin/vuex.js";
import { searchable } from "@/components/mixin/searchable.js";
import { filterable } from "@/components/mixin/filterable.js";
import { LayerService } from "@/services/layers/layerService.js";
import { mapService } from "@/services/map/mapService";

export default {
  name: "HelloWorld",
  props: ["isFixed"],
  mixins: [draggableDiv, vuex, searchable, filterable],
  data() {
    return {
      isHidden: false,
      selectedCategories: [],
      filterTypes: [
        { value: "all", label: "Todas" },
        { value: "category", label: "Por Categoría" },
        { value: "active", label: "Solo Activas" },
      ],
    };
  },
  components: {
    ListPlegable,
  },
  computed: {
    isActive: function () {
      return this.isFixed
        ? this.isMobile
        : this.mapToolValues("layers").active && !this.isMobile;
    },

    /**
     * Get layers from Vuex store
     */
    layers() {
      return this.$store.getters.getLayers || [];
    },

    /**
     * Get all categories for filter checkboxes
     */
    allCategories() {
      return this.layers.map((cat, index) => ({
        id: index,
        name: cat.name,
      }));
    },

    /**
     * Check if all categories are selected
     */
    allCategoriesSelected() {
      return this.selectedCategories.length === this.allCategories.length;
    },

    /**
     * Get filtered categories based on search and filters
     * IMPORTANT: Apply filters in the correct order:
     * 1. Category filter (filter which categories to include)
     * 2. Active filter (filter which layers within categories)
     * 3. Search (search within the filtered set)
     */
    filteredCategories() {
      let categories = this.layers;

      // Step 1: Apply category filter FIRST (filter which categories to show)
      if (this.currentFilterType === "category" && this.selectedCategories.length > 0) {
        categories = categories.filter((cat, index) =>
          this.selectedCategories.includes(index)
        );
      }

      // Step 2: Apply active filter (filter layers within categories)
      if (this.currentFilterType === "active") {
        categories = categories
          .map((cat) => ({
            ...cat,
            layers: cat.layers ? cat.layers.filter((layer) => layer.selected) : [],
          }))
          .filter((cat) => cat.layers.length > 0);
      }

      // Step 3: Apply search LAST (search within the filtered categories)
      if (this.hasSearchQuery) {
        categories = this.searchCategories(categories);
      }

      return categories;
    },

    /**
     * Count total filtered layers
     */
    filteredLayersCount() {
      return this.filteredCategories.reduce(
        (count, cat) => count + (cat.layers ? cat.layers.length : 0),
        0
      );
    },

    /**
     * Get the appropriate label for the reset/clear button
     */
    resetButtonLabel() {
      if (this.currentFilterType === "category") {
        return "Limpiar Filtro";
      } else if (this.currentFilterType === "active") {
        return "Apagar Todos";
      }
      return "Limpiar todo";
    },
  },

  methods: {
    /**
     * Perform search on button click
     * Overrides searchable mixin method
     */
    performSearch() {
      if (!this.searchQuery.trim()) return;

      this.isSearching = true;
      this.addToSearchHistory();
      this.saveSearchState();

      // Use setTimeout to show loading state briefly
      setTimeout(() => {
        this.isSearching = false;
      }, 100);
    },

    /**
     * Search through categories and layers
     * @param {Array} categories - Categories to search
     * @returns {Array} Filtered categories with search metadata
     */
    searchCategories(categories) {
      const query = this.searchQuery.toLowerCase().trim();
      if (!query) return categories;

      return categories
        .map((category) => {
          const categoryMatches = category.name.toLowerCase().includes(query);
          const matchingLayers = category.layers
            ? category.layers.filter((layer) => layer.name.toLowerCase().includes(query))
            : [];

          if (categoryMatches || matchingLayers.length > 0) {
            return {
              ...category,
              layers: categoryMatches ? category.layers : matchingLayers,
              isMatch: categoryMatches,
              hasMatchingChildren: matchingLayers.length > 0,
              matchCount: matchingLayers.length,
              autoExpand: true, // Signal to child component to auto-expand
            };
          }
          return null;
        })
        .filter(Boolean);
    },

    /**
     * Set filter type
     */
    setFilterType(type) {
      this.currentFilterType = type;
      this.saveFilterState();
    },

    /**
     * Reset filters based on current filter type
     * - In "Por Categoría": Clear category selections, stay in that view
     * - In "Solo Activas": Uncheck all active layers, return to "Todos"
     * - Otherwise: Clear everything and return to "Todos"
     */
    resetAllFilters() {
      if (this.currentFilterType === "category") {
        // Limpiar Filtro: Clear search and category selections, but stay in "Por Categoría" view
        this.clearSearch();
        this.selectedCategories = [];
        // Keep currentFilterType as 'category'
      } else if (this.currentFilterType === "active") {
        // Apagar Todos: Uncheck all active layers, then return to "Todos"
        this.uncheckAllActiveLayers();
        this.clearSearch();
        this.currentFilterType = "all";
      } else {
        // Default: Clear everything and return to "Todos"
        this.clearSearch();
        this.clearAllFilters();
        this.selectedCategories = [];
      }
    },

    /**
     * Uncheck all active layers (set selected = false)
     */
    uncheckAllActiveLayers() {
      // Get all active layers from store
      const activeLayers = this.$store.getters.getActiveLayers || [];

      // Uncheck each layer by setting selected = false
      activeLayers.forEach((activeLayer) => {
        const originalLayer = this.findLayerById(activeLayer.id);
        if (originalLayer) {
          this.$set(originalLayer, "selected", false);
          // Also remove from active layers in store
          this.$store.dispatch("removeActiveLayer", originalLayer);
          this.executeMapToolAction("layers", "removeLayer", originalLayer);
        }
      });
    },

    /**
     * Toggle all categories selection
     */
    toggleAllCategories() {
      if (this.allCategoriesSelected) {
        this.selectedCategories = [];
      } else {
        this.selectedCategories = this.allCategories.map((cat) => cat.id);
      }
    },

    /**
     * Handle layer selection
     * @param {Object} category - Category object
     * @param {Object} layer - Layer object to select
     */
    onClickSelectLayer: function (category, layer) {
      console.log("Seleccionando capa a cargar:", layer);
      const originalLayer = this.findLayerById(layer.id);
      if (originalLayer) {
        LayerService.addLayerToMap(originalLayer);
        this.$store.dispatch('addActiveLayer', originalLayer);
      } else {
        console.error("Layer not found in store:", layer);
      }
    },

    /**
     * Handle layer removal
     * @param {Object} category - Category object
     * @param {Object} layer - Layer object to remove
     */
    onClickRemoveLayer: function (category, layer) {
      console.log("Se selecciono para eliminar la capa:", layer);
      LayerService.removeLayerByID(layer.id);

      // Remove from active layers in store
      const originalLayer = this.findLayerById(layer.id);
      if (originalLayer) {
        this.$store.dispatch('removeActiveLayer', originalLayer);
      }
    },
    onUpdateOpacity: function (payload) {
      const { category, layer, opacity } = payload;
      const originalLayer = this.findLayerById(layer.id);

      if (originalLayer) {
        this.$set(originalLayer, 'opacity', opacity);

        // Actualizar opacidad en el mapa via servicio
        mapService.setLayerOpacity(layer.id, opacity);
      }
    },
    exitLayers: function () {
      this.selectMapTool("layers", false);
    },
    /**
     * Get layer information for attributes table
     * @param {Object} category - Category object
     * @param {Object} layer - Layer object
     */
    getLayerInfo: function (category, layer) {
      console.log("getLayerInfo", layer);
      // Find the layer in the original store by ID
      const originalLayer = this.findLayerById(layer.id);
      if (!originalLayer) {
        console.error("Layer not found in store:", layer);
        return;
      }
      const layerProvider = originalLayer.provider.name;
      switch (layerProvider) {
        case "geoserver":
          this.geoserverFeatures(originalLayer);
          break;

        case "arcgis":
          this.arcgisFeatures(originalLayer);
          break;
        default:
          console.error(
            "Unsupported layer provider for attributes table:",
            layerProvider
          );
          return;
      }
    },

    /**
     * Find a layer by its ID in the original store
     * @param {string} layerId - Layer ID to find
     * @returns {Object|null} Layer object or null if not found
     */
    findLayerById: function (layerId) {
      for (const category of this.layers) {
        const layer = category.layers.find((l) => l.id === layerId);
        if (layer) {
          return layer;
        }
      }
      return null;
    },
    geoserverFeatures: function (layer) {
      console.log("geoserverFeatures", layer);
      let totalRecords = 0;
      let workspace = layer.provider.geoserverdata.workspace;
      let datastore = layer.provider.geoserverdata.datastore;
      let typeName = workspace + ":" + datastore;

      // Construct proper WFS GetFeature URL
      let baseUrl = layer.provider.url + "/wfs";
      let url =
        baseUrl +
        "?service=WFS&version=2.0.0&request=GetFeature&typeNames=" +
        encodeURIComponent(typeName) +
        "&count=1&outputFormat=application/json";
      console.log("WFS GetFeature URL: ", url);
      fetch(url)
        .then((res) => {
          return res.json();
        })
        .then((data) => {
          totalRecords = data.totalFeatures;
          this.executeMapToolAction("attributesTable", "paginationInfo", {
            offset: 0,
            totalRecords: totalRecords,
            layer: layer,
          });
          this.selectMapTool("attributesTable", true);
          return totalRecords;
        })
        .catch((err) => {
          console.error("Error fetching WFS data: ", err);
          return 0;
        });
    },
    arcgisFeatures: function (layer) {
      var totalRecords = 0;
      var subLayers = [];
      var that = this;

      var req = new XMLHttpRequest();
      req.open("GET", layer.provider.url + "?f=json&pretty=true", false);
      req.withCredentials = false;
      req.send();
      console.log("Request ArcGIS Attributes: ", req);

      if (req.status == 200) {
        console.log("Success Attribute query 1");
        var resp = JSON.parse(req.response);
        console.log("sublayer", resp.layers);
        subLayers = resp.layers;

        var req2 = new XMLHttpRequest();
        req2.open(
          "GET",
          layer.provider.url + "/0/query?where=objectid>0&returnCountOnly=true&f=pjson",
          false
        );
        req2.withCredentials = false;
        req2.send();

        if (req2.status == 200) {
          console.log("Success Attribute query 2");
          var resp2 = JSON.parse(req2.response);
          totalRecords = resp2.count;
          that.executeMapToolAction("attributesTable", "paginationInfo", {
            offset: 0,
            totalRecords: totalRecords,
            layer: layer,
            layerId: 0,
            subLayers: subLayers,
          });
          that.selectMapTool("attributesTable", true);
          this.searchError = true;
          return;
        } else {
          console.log("Fail Attribute query 2");
        }
      } else {
        console.log("Fail Attribute query 1");
      }
    },
    onClickModalNewLayer: function () {
      this.$router.push("/capas/nueva-capa");
    },
  },
  updated() { },
  created() { },
  mounted() {
    if (!this.isFixed) {
      this.makeDraggable("layersID");
    }
  },
};
</script>

<style scoped lang="scss">
.resizable {
  margin-top: 0.5em;
  height: 40vh;
  min-height: 20vh;
  min-width: 20vw;
  resize: both;
  overflow: auto;
}

.fixedWidget {
  margin-top: 0.5em;
  height: 100vh;
  min-height: 20vh;
  min-width: 20vw;
  resize: none;
  overflow: hidden;
}

.scrollable {
  height: 110px;
  overflow-y: scroll;
}

/* Search and Filter Section - Bold Contrast Design */
.search-filter-section {
  padding: 12px;
  background: rgba(255, 255, 255, 0.95);
  border-bottom: 2px solid #004b7a;
}

.search-bar-container {
  display: flex;
  gap: 8px;
  align-items: stretch;
}

.search-bar {
  position: relative;
  display: flex;
  align-items: center;
  flex: 1;
  background: #ffffff;
  border: 2px solid #004b7a;
  border-radius: 6px;
  padding: 8px 12px;
  transition: all 0.2s;

  &:focus-within {
    border-color: #006fb3;
    box-shadow: 0 0 0 3px rgba(0, 111, 179, 0.1);
  }
}

.search-icon {
  color: #006fb3;
  margin-right: 8px;
  font-size: 16px;
  font-weight: bold;
}

/* Typing Dots Indicator - Conversational Design */
.typing-dots {
  display: inline-flex;
  gap: 3px;
  align-items: center;
  margin-left: 4px;

  span {
    width: 4px;
    height: 4px;
    background: #006fb3;
    border-radius: 50%;
    animation: bounce-dot 1s infinite ease-in-out;

    &:nth-child(1) {
      animation-delay: 0s;
    }

    &:nth-child(2) {
      animation-delay: 0.15s;
    }

    &:nth-child(3) {
      animation-delay: 0.3s;
    }
  }
}

@keyframes bounce-dot {

  0%,
  60%,
  100% {
    transform: translateY(0);
    opacity: 1;
  }

  30% {
    transform: translateY(-6px);
    opacity: 0.7;
  }
}

/* Pulse Wave Accent Bar - Minimalist Industrial */
.debounce-pulse-bar {
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 100%;
  height: 2px;
  background: linear-gradient(90deg,
      transparent 0%,
      #006fb3 25%,
      #4caf50 50%,
      #006fb3 75%,
      transparent 100%);
  background-size: 200% 100%;
  animation: pulse-wave 1.2s ease-in-out infinite;
  border-radius: 1px;
}

@keyframes pulse-wave {

  0%,
  100% {
    background-position: 200% 0;
    opacity: 0.7;
  }

  50% {
    background-position: -200% 0;
    opacity: 1;
  }
}

.search-input {
  flex: 1;
  border: none;
  outline: none;
  font-size: 14px;
  background: transparent;
  color: #222;
  font-weight: 500;

  &::placeholder {
    color: #999;
    font-weight: normal;
  }
}

.clear-button {
  background: transparent;
  border: none;
  color: #b0413e;
  cursor: pointer;
  padding: 4px 8px;
  transition: all 0.2s;
  font-size: 14px;

  &:hover {
    color: #8b332f;
    transform: scale(1.1);
  }
}

.search-button {
  min-width: 80px;
  font-weight: bold;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

/* Filter Type Selector */
.filter-type-selector {
  display: flex;
  gap: 6px;
  margin-top: 10px;
}

.filter-btn {
  flex: 1;
  background: #ffffff;
  border: 2px solid #004b7a;
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
  color: #006fb3;

  &:hover {
    background: #f5f5f5;
    border-color: #006fb3;
  }

  &.active {
    background: #006fb3;
    color: #ffffff;
    border-color: #006fb3;
    box-shadow: 0 2px 4px rgba(0, 111, 179, 0.3);
  }
}

/* Category Filter */
.category-filter {
  margin-top: 10px;
  padding: 12px;
  background: #ffffff;
  border: 2px solid #004b7a;
  border-radius: 6px;
}

.filter-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  padding-bottom: 8px;
  border-bottom: 1px solid #ddd;
}

.filter-title {
  font-weight: 700;
  font-size: 13px;
  color: #006fb3;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.link-button {
  background: transparent;
  border: none;
  color: #006fb3;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  text-decoration: underline;
  padding: 4px 8px;

  &:hover {
    color: #004b7a;
    background: rgba(0, 111, 179, 0.05);
    border-radius: 4px;
  }
}

.category-checkboxes {
  max-height: 200px;
  overflow-y: auto;

  /* Custom scrollbar */
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #006fb3;
    border-radius: 4px;

    &:hover {
      background: #004b7a;
    }
  }
}

.checkbox-item {
  display: flex;
  align-items: center;
  padding: 6px 4px;
  border-radius: 4px;
  transition: background 0.15s;

  &:hover {
    background: rgba(0, 111, 179, 0.05);
  }

  input[type="checkbox"] {
    margin-right: 8px;
    cursor: pointer;
  }

  label {
    font-size: 13px;
    cursor: pointer;
    margin: 0;
    font-weight: normal;
    color: #222;
  }
}

/* Result Summary */
.result-summary {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  padding: 10px 12px;
  background: #ffffff;
  border: 2px solid #006fb3;
  border-radius: 6px;
  font-size: 13px;
}

.result-count {
  font-weight: 700;
  color: #006fb3;
  font-size: 14px;
}

.reset-button {
  background: transparent;
  border: 2px solid #b0413e;
  color: #b0413e;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 12px;
  border-radius: 4px;
  transition: all 0.15s;

  &:hover {
    background: #b0413e;
    color: #ffffff;
  }
}

/* Loading State */
.loading-state {
  padding: 16px;
}

.skeleton-item {
  height: 50px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  margin-bottom: 10px;
  border-radius: 6px;
  border: 2px solid #ddd;
}

@keyframes loading {
  0% {
    background-position: 200% 0;
  }

  100% {
    background-position: -200% 0;
  }
}

/* Empty State */
.empty-state {
  text-align: center;
  padding: 40px 20px;
  color: #666;
}

.empty-icon {
  font-size: 48px;
  color: #ccc;
  margin-bottom: 16px;
}

.empty-state h3 {
  font-size: 18px;
  font-weight: 700;
  color: #333;
  margin-bottom: 8px;
}

.empty-state p {
  font-size: 14px;
  color: #666;
  margin-bottom: 16px;
}

/* Transitions */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}
</style>
